var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title && _vm.text)?_c('v-card',{staticClass:"card-information"},[_c('div',{staticClass:"text-caption text-sm-body-2 grey--text text--darken-1 font-weight-medium"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"text-subtitle-1 text-sm-h6 font-weight-bold mt-1"},[_vm._v(" "+_vm._s(_vm.text)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }